import React, { Component } from 'react';
import { connect } from 'react-redux';
import { changePassword } from '../../actions/password/change'
import { Button, Form, Grid, Header, Segment, Label } from 'semantic-ui-react'
import '../../App.css';
import { SYSTEM_TITLE } from '../../constants'

class ChangePassword extends Component {
  constructor(props){
    super(props);
    this.state = {
      confirm_password: '',
      token: this.props.match.params.token,
      new_password: '',
      confirm_password: ''
    }
  }

  //Set the messageShown state to TRUE before the props are updated
  componentWillReceiveProps(nextProps){
    this.setState({
      messageShown: true
    })

    if(this.state.messageShown && !this.props.changeFailure) {
      this.setState({
        new_password: '',
        confirm_password: ''
      })
    }
  }

  showForm() {
    if(this.state.messageShown && !this.props.changeFailure && !this.props.pending) {
      return
    }

    return (
      <div>
        <Header as='h2' color='teal' textAlign='center'>
          Change your password
        </Header>
        <Form size='large'>
          <Segment>
            <Form.Input
              fluid
              icon='lock'
              iconPosition='left'
              placeholder='New password (6 characters minimum)'
              type='password'
              onChange={event => this.setState({new_password: event.target.value})}
              value={this.state.new_password}
            />
            <Form.Input
              fluid
              icon='lock'
              iconPosition='left'
              placeholder='Confirm new password'
              type='password'
              onChange={event => this.setState({confirm_password: event.target.value})}
              value={this.state.confirm_password}
            />
            <Button loading={this.props.pending} color='teal' fluid size='large' onClick={() => this.props.changePassword({password:this.state.new_password, password_confirmation:this.state.confirm_password, reset_password_token:this.state.token})}>Change password</Button>
          </Segment>
        </Form>
      </div>
    )
  }

  showMessage() {
    if(!this.props.pending) {
      if(!this.props.changeFailure) {
        return (<Header as='h4' color='teal' textAlign='center'><p>Your password has been changed</p><Button color='teal' href="/">Log in</Button></Header>)
      }
      else {
        var messages = []

        if(this.props.error == "Bad Request") {
          messages.push("An error occurred while changing the password.")
        }
        else {
          Object.keys(this.props.error).map((error_type, index) => {
            if(error_type == "password") {
              messages.push("Password " + this.props.error[error_type][0])
            }
            else if(error_type == "password_confirmation") {
              messages.push("Password confirmation " + this.props.error[error_type][0])
            }
            else if(error_type == "reset_password_token") {
              messages.push("Reset password link has expired!")
            }
          });
        }
        return <Label color='red'>{messages.map((item, i) => <p key={i}> {item}</p>)}</Label>
      }
    }
  }

  render(props) {
    return (
      <div>
        <header className="App-header">
          <h1 className="App-title">{SYSTEM_TITLE}</h1>
        </header>
        <div className='change-password-form'>
          <Grid
            textAlign='center'
            style={{ height: '100%' }}
            verticalAlign='middle'
          >
            <Grid.Column style={{ maxWidth: 450 }}>
              {this.showForm()}
              {this.state.messageShown && this.showMessage()}
            </Grid.Column>
          </Grid>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    pending: state.change_password.pending,
    changeFailure: state.change_password.changeFailure,
    error: state.change_password.error,
    error_type: state.change_password.error_type
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    changePassword: (details) => {
      dispatch(changePassword(details))
    }
  }
}

let ChangePasswordPage = connect(mapStateToProps, mapDispatchToProps)(ChangePassword)
export default ChangePasswordPage;



// WEBPACK FOOTER //
// ./src/views/password/change.js